import React from "react";
import { FaFileAlt, FaClipboardCheck, FaLightbulb, FaWater, FaUsers } from "react-icons/fa";

function FeatureCard({ icon: Icon, title, description }) {
  return (
    <div className="col-lg-4 col-md-6 process-two-single">
      <div className="services-style-two-item fade-up-anim">
        <div className="top-info">
          <div className="icon" style={{ fontSize: "40px", color: "#007bff" }}>
            <Icon />
          </div>
          <h4><a>{title}</a></h4>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
}

function DetailedListing() {
  const features = [
    {
      title: "Detailed Listing Preparation",
      description: "End-to-end guidance in assembling the required documentation and aligning with platform listing standards for a successful submission.",
      icon: FaFileAlt,
    },
    {
      title: "Platform-Specific Compliance",
      description: "Support in navigating the unique requirements of various listing platforms, ensuring regulatory compliance and adherence to each platform's criteria.",
      icon: FaClipboardCheck,
    },
    {
      title: "Market Positioning Strategy",
      description: "Development of a customized listing strategy to maximize your token’s visibility and traction across the market.",
      icon: FaLightbulb,
    },
    {
      title: "Liquidity Solutions",
      description: "Ongoing liquidity management solutions designed to stabilize trading, promote market confidence, and attract investor interest.",
      icon: FaWater,
    },
    {
      title: "Community Engagement & Marketing",
      description: "Comprehensive marketing plans and engagement strategies to drive token visibility and build a loyal community.",
      icon: FaUsers,
    },
  ];

  return (
    <div className="services-style-two-area default-padding bg-gray blurry-shape-right-bottom">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h4 className="sub-title">What we do</h4>
              <h2 className="title split-text-right split-text-in-right">
                Key Features of Our Token Listing Service
              </h2>
            </div>
          </div>
        </div>
        <div className="container fade-up-anim">
          <div className="row">
            {features.map((feature, idx) => (
              <FeatureCard key={idx} {...feature} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailedListing;